<template>
  <div class="sku_section" v-if="antInstallment.installmentQuantity">
    <div :class="antInstallment.installmentQuantity > 2 ? 'tab-sku-installment' : 'sku-installment'">
      <div class="section_title">
        <span class="title">{{ title }}</span>
      </div>
      <div class="section_content center-section">
        <div class="sku_btn" :class="{'sku_btn--checked': fqType == 1}" v-if="hbInstallmentList.length" @click="toggleTypeInstallment(1)">
          <div>花呗分期</div>
        </div>
        <div class="sku_btn" :class="{'sku_btn--checked': fqType == 2}" v-if="bankInstallmentList.length" @click="toggleTypeInstallment(2)">
          <div>信用卡分期</div>
        </div>
        <div class="sku_btn" :class="{'sku_btn--checked': fqType == 3}" v-if="selfInstallmentList.length" @click="toggleTypeInstallment(3)">
          <div>丰融分期</div>
          <span class="badge" v-if="antInstallment.selfInstallment.creditCorner"><i class="text">{{ antInstallment.selfInstallment.creditCorner }}</i></span>
        </div>
      </div>
    </div>
    <!-- 花呗分期 -->
    <div class="sku_section sku-installment" v-if="hbInstallmentList.length" v-show="fqType == antInstallmentArr[1].value">
      <div class="sub-title">选择期数</div>
      <div class="section_content">
        <div
          class="sku_btn"
          v-for="(installmentInfo, index) in hbInstallmentList"
          :key="index"
          :class="{ 'sku_btn--checked': antInstallmentArr[1].fqNum == installmentInfo.num, 't-c': !installmentInfo.userPerFeePay }"
          tabindex="0"
          @click="toggleInstallment(installmentInfo, 1)"
        >
          <div :aria-label="antInstallmentArr[1].fqNum == installmentInfo.num ? '已选中,' : '未选中,'">
            <span
              class="name"
              :class="{ 'fixed-width': installmentInfo.userPerFeePay }"
              :aria-label="`${installmentInfo.perPay}元乘${installmentInfo.num}期`"
            >
              ¥{{ installmentInfo.perPay }}x{{ installmentInfo.num }}期
            </span>
          </div>
          <template v-if="installmentInfo.userPerFeePay">
            <span class="item fs-30">含利息</span>
          </template>
          <span class="badge" v-else>
            <i class="text">免息</i>
          </span>
        </div>
      </div>
    </div>
    <!-- 信用卡分期 -->
    <div class="sku_section sku-installment" v-if="bankInstallmentList.length" v-show="fqType == antInstallmentArr[2].value">
      <div class="sub-title">选择信用卡</div>
      <div class="bank-warp">
        <div class="section_content center-section" :class="bankInstallmentList.length < 4 ? 'single-line' : 'multi-line'">
          <div
            class="sku_btn bank-item"
            v-for="(installmentInfo, index) in bankInstallmentList"
            :key="installmentInfo.bankCode"
            :class="{ 'sku_btn--checked': currentBankCode == installmentInfo.bankCode }"
            :tabindex="index"
            @click="toggleBankInstallment(installmentInfo)"
          >
            <span
              class="name"
              :aria-label="currentBankCode == installmentInfo.bankCode ? `已选中,${installmentInfo.bankName}` : `未选中,${installmentInfo.bankName}`"
            >
              <img v-if="installmentInfo.bankLogoPic" class="bank-pic" :src="installmentInfo.bankLogoPic" :alt="installmentInfo.bankName">
              {{ installmentInfo.bankName }}
            </span>
            <span class="badge" v-if="installmentInfo.label">
              <i class="text">{{ installmentInfo.label }}</i>
            </span>
          </div>
        </div>
      </div>
      <div v-show="currentBankCode">
        <div class="sub-title">选择期数</div>
        <div class="section_content" v-for="installmentList in bankInstallmentList" :key="installmentList.bankCode" v-show="currentBankCode == installmentList.bankCode">
          <div
            class="sku_btn"
            v-for="(installmentInfo, index) in installmentList.perInstallmentInfoList"
            :key="index"
            :class="{ 'sku_btn--checked': antInstallmentArr[2].fqNum == installmentInfo.num, 't-c': !installmentInfo.userPerFeePay }"
            tabindex="0"
            @click="toggleInstallment(installmentInfo, 2)"
          >
            <div :aria-label="antInstallmentArr[2].fqNum == installmentInfo.num ? '已选中,' : '未选中,'">
              <span
                class="name"
                :class="{ 'fixed-width': installmentInfo.userPerFeePay }"
                :aria-label="`${installmentInfo.perPay}元乘${installmentInfo.num}期`"
              >
                ¥{{ installmentInfo.perPay }}x{{ installmentInfo.num }}期
              </span>
            </div>
            <template v-if="installmentInfo.userPerFeePay">
              <span class="item fs-30">含利息</span>
            </template>
            <span class="badge" v-else>
              <i class="text">免息</i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- 丰融分期 -->
    <div class="sku_section sku-installment" v-if="selfInstallmentList.length" v-show="fqType == antInstallmentArr[3].value">
      <div class="sub-title">选择期数</div>
      <div class="section_content">
        <div
          class="sku_btn"
          v-for="(installmentInfo, index) in selfInstallmentList"
          :key="index"
          :class="{ 'sku_btn--checked': antInstallmentArr[3].fqNum == installmentInfo.num, 't-c': !installmentInfo.userPerFeePay }"
          tabindex="0"
          @click="toggleInstallment(installmentInfo, 3)"
        >
          <div :aria-label="antInstallmentArr[3].fqNum == installmentInfo.num ? '已选中,' : '未选中,'">
            <span
              class="name"
              :aria-label="`${installmentInfo.perPay}${isLowest}元乘${installmentInfo.num}期`"
            >
              ¥{{ installmentInfo.perPay }}{{isLowest}}x{{ installmentInfo.num }}期
            </span>
          </div>
          <template v-if="installmentInfo.userPerFeePay">
            <span class="item fs-30">含利息</span>
          </template>
          <span class="badge" v-else>
            <i class="text">免息</i>
          </span>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'SkuInstallment',
  props: {
    skuId: [Number, String],
    money: Number,
    fqType: Number,
    fqNum: Number,
    installment: Object,
    trackData: Object
  },
  data() {
    return {
      antInstallmentArr: [
        {}, // 我是占岗的，很重要！别删！
        {
          label: '花呗分期',
          value: 1,
          fqNum: 0
        },
        {
          label: '信用卡分期',
          value: 2,
          fqNum: 0,
          fqBank: 0
        },
        {
          label: '丰融分期',
          value: 3,
          fqNum: 0
        },
      ],
      currentBankCode: 0,
      swiperOption: {
        slidesPerView: 3,
        slidesPerColumn: 2
      },
      antInstallment: null, // 当前选择的sku对应的分期信息
      antInstallmentList: {} // 所有sku的花呗分期信息，以skuId + money 作为key, 只有自己请求分期信息时才会做缓存，否则取传递下来的数据
    }
  },
  computed: {
    title() {
      const ua = navigator.userAgent.toLowerCase()
      if (/Bankabc/i.test(ua)) {
        return '农行分期'
      } else {
        return '分期付款'
      }
    },
    hbInstallmentList() { // 花呗
      return this.antInstallment?.hbInstallment?.perInstallmentInfoList || []
    },
    bankInstallmentList() { // 银联
      let bankInstallmentList = this.antInstallment?.unionPayInstallment?.bankInstallmentList || []
      // 支付侧后上线，兼容开关关闭前未返回银行分期的场景
      if ( bankInstallmentList.length && !(bankInstallmentList[0].perInstallmentInfoList || []).length ) {
        return []
      }
      return bankInstallmentList
    },
    isLowest() {
      return this.antInstallment?.selfInstallment?.creditStatus !== 2 ? '起' : ''
    },
    selfInstallmentList() { // 丰融
      return this.antInstallment?.selfInstallment?.perInstallmentInfoList || []
    },
    // 分期的依赖，如果这些依赖有变化，需要重新请求分期信息
    dep() {
      return {
        skuId: this.skuId,
        money: this.money
      }
    }
  },
  watch: {
    installment: {
      deep: true,
      immediate: true,
      handler(val) {
        this.antInstallment = val
      }
    },
    fqType: {
      handler(val) {
        // 切换sku时重置选中项
        if (!val) {
          this.currentBankCode = 0
          this.antInstallmentArr.forEach(element => {
            element.fqNum = 0
          })
        }
      }
    }
  },
  created() {
  },
  methods: {
    toggleTypeInstallment(type) {
      this.$emit('fqTypeChange', type)
      let currentFq = this.antInstallmentArr[type]
      if (this.fqType !== type) {
        if (type == 1) {
          currentFq.fqNum = this.antInstallmentArr[type].fqNum || this.hbInstallmentList[0].num
        }
        if (type == 2) {
          this.currentBankCode = this.antInstallmentArr[type].fqBank || this.bankInstallmentList[0].bankCode
          currentFq.fqBank = this.currentBankCode
          currentFq.fqNum = this.antInstallmentArr[type].fqNum || this.bankInstallmentList[0].perInstallmentInfoList[0].num
          this.$emit('fqBankChange', this.currentBankCode)
        }
        if (type == 3) {
          currentFq.fqNum = this.antInstallmentArr[type].fqNum || this.selfInstallmentList[0].num
        }
        this.$emit('fqNumChange', currentFq.fqNum)
      }
      // 点击埋点
      let data = this.trackData
      data.event_id = '154|007|01|077'
      data.button = this.antInstallmentArr[type].label
      this.$track(data)
    },
    toggleBankInstallment(bank) {
      // 点击埋点
      if (this.currentBankCode !== bank.bankCode) {
        let data = this.trackData
        data.event_id = '154|007|01|077'
        data.button = this.antInstallmentArr[this.fqType].label + '_' + bank.bankName
        this.$track(data)
      }
      if (bank.bankCode) {
        this.currentBankCode = bank.bankCode
        const currentBankNum = bank.perInstallmentInfoList[0].num
        this.antInstallmentArr[2].fqNum = currentBankNum
        this.antInstallmentArr[2].fqBank = this.currentBankCode
        this.$emit('fqNumChange', currentBankNum)
        this.$emit('fqBankChange', this.currentBankCode)
      }
    },
    // 切换分期信息
    toggleInstallment(installmentInfo, idx) {
      const antInstallmentArr = this.antInstallmentArr[idx]
      // 点击埋点
      if (antInstallmentArr.fqNum !== installmentInfo.num) {
        let data = this.trackData
        data.event_id = '154|007|01|077'
        data.button = this.antInstallmentArr[this.fqType].label + '_' + installmentInfo.num + '期'
        this.$track(data)
      }
      antInstallmentArr.fqNum = installmentInfo.num
      this.$emit('fqNumChange', installmentInfo.num)
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
